import Icon, { __ICONNAMES__ } from './icon'

export default Icon
export { __ICONNAMES__ }
